import { createRouter, createWebHistory } from "vue-router";

const routes = [
  {
    path: "/",
    name: 'Inicio',
    component: () =>
      //import(/* webpackChunkName: "home" */ "../components/Catalogo"),
      import(/* webpackChunkName: "home" */ "../components/Catalogo"),
  },
  {
    path: "/catalogo/:filter?",
    name: 'Catálogo',
    params: true,
    component: () =>
      import(/* webpackChunkName: "catalogo" */ "../components/Catalogo"),
  },
  {
    path: "/preventas",
    name: 'Preventas',
    component: () =>
      import(/* webpackChunkName: "catalogo" */ "../components/Preventas"),
  },
  {
    path: "/descuentos",
    name: 'Descuentos',
    params: true,
    component: () =>
      import(/* webpackChunkName: "catalogo" */ "../components/pages/Descuentos"),
  },
  // {
  //   path: "/puntosEntrega",
  //   name: 'Entrega',
  //   component: () =>
  //     import(
  //       /* webpackChunkName: "agregarNuevoPop" */ "../components/pages/PuntosEntrega"
  //     ),
  // },
  {
    path: "/encuestas",
    name: 'Encuestas',
    component: () =>
      import(
        /* webpackChunkName: "agregarNuevoPop" */ "../components/Encuestas"
      ),
  },
  {
    //path: "/encuestas/encuesta/:id",
    path: "/encuestas/encuesta/:id",
    name: "encuesta",
    params: true,
    component: () =>
      import(/* webpackChunkName: "pop" */ "../components/pages/Encuesta"),
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
